<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-img class="white--text" height="400px" src="/images/gerard-naughty.jpg">
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <!-- <span class="headline">Welcome to the Coletti-Spaghetti Birthday Quiz</span> -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-card-title>
          <div>
            <span class="grey--text">Question 1</span>
            <br>
            <!-- <span>Are you ready?</span><br> -->
            <span>This guy wants to play football in the back yard. What do you do?</span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="$store.question" :disabled="getShowAnswer">
            <v-radio
              @change="updateAnswer({value:$event,isCorrect:true})"
              label="Put your shin pads on and get ready rumble."
              value="Correct: I always wanted you to be good at football and you only learn through practice."
            ></v-radio>
            <v-radio
              @change="updateAnswer({value:$event,isCorrect:false})"
              label="Go back inside Boscoe will be on soon."
              value="Wrong: You will never learn to be good at football if you don't try."
            ></v-radio>
          </v-radio-group>
          <span v-if="getShowAnswer" >{{ getAnswer }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="getAnswer && !getShowAnswer" @click="showAnswer()" >Get Answer</v-btn>
          <v-btn v-if="getShowAnswer" to="/question2" flat color="orange">Next Question</v-btn>
          <v-spacer></v-spacer><span class="grey--text">Current score: {{getScore}}</span>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
export default {
  methods: mapMutations(['showAnswer', 'updateAnswer', 'nextQuestion']),
  computed: mapGetters(['getScore', 'getAnswer', 'getShowAnswer']),
    created() {
     this.$store.dispatch('resetQuestion');
   },
};
</script>
